import React from 'react'

export const CandidateDetailHeader = ({ children }) => {
  return (
    <h3 className="font-sans text-xl font-bold uppercase lg:text-2xl">
      {children}
    </h3>
  )
}
